/** Small layout rules of the glass chrome, kept out of the components so they can be tested. */

/** Phones and small tablets: the compact header, the minimised tools column, wide snapping theme cards. */
export const PHONE_MAX_WIDTH = 860;

/**
 * Is the left map-tools column minimised? Default: minimised on a phone (a clean full-screen map; the column
 * would otherwise run into the bottom carousel), shown on desktop. Once toggled, the stored choice wins.
 */
export function toolsMinimised(stored: string | null, viewportWidth: number): boolean {
  if (stored === null) return viewportWidth <= PHONE_MAX_WIDTH;
  return stored === '1';
}

/**
 * Scroll position that rests the active theme card in view: centred where it can be, clamped to the ends.
 * Null when the track does not overflow (nothing to scroll).
 */
export function centredScrollLeft(
  cardLeft: number,
  cardWidth: number,
  trackWidth: number,
  scrollWidth: number,
): number | null {
  const overflow = scrollWidth - trackWidth;
  if (overflow <= 4) return null;
  const target = cardLeft - Math.max(0, (trackWidth - cardWidth) / 2);
  return Math.max(0, Math.min(target, overflow));
}
